import { render, staticRenderFns } from "./SeletorProduto.vue?vue&type=template&id=0cdb3838&"
import script from "./SeletorProduto.vue?vue&type=script&lang=js&"
export * from "./SeletorProduto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports